<article
  class="onboarding-mini-table ch-api-card"
  [class.onboarding-mini-table--dark]="isDarkMode"
  [class.ch-api-card--editing]="isEditing"
>
  <header class="onboarding-mini-table__header ch-api-card__header">
    <h3 class="onboarding-mini-table__title ch-api-card__title">{{ section.title }}</h3>
    <div class="onboarding-mini-table__actions" *ngIf="canEdit">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm ch-api-edit-btn"
        *ngIf="!isEditing"
        (click)="startEdit()"
      >
        <mat-icon>edit</mat-icon> Edit
      </button>
      <ng-container *ngIf="isEditing">
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          [disabled]="saving"
          (click)="cancelEdit()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          [disabled]="saving"
          (click)="saveSection()"
        >
          <mat-icon>save</mat-icon>
          {{ saving ? 'Saving…' : 'Save' }}
        </button>
      </ng-container>
    </div>
  </header>

  <div class="onboarding-mini-table__body ch-api-card__body">
  <div class="onboarding-mini-table__content" *ngIf="hasKvRows || hasTableRows || uploadedFiles.length">
    <table class="module-kv-table ch-api-kv-table" *ngIf="hasKvRows">
      <tbody>
        <tr
          class="no-hover onboarding-detail-row"
          *ngFor="let row of (isEditing ? draftRows : section.rows); trackBy: trackRow"
        >
          <th>{{ row.label }}</th>
          <td>
            <input
              *ngIf="isEditing && !row.readOnly"
              class="form-control form-control-sm onboarding-mini-table__input"
              [type]="row.type === 'number' ? 'number' : 'text'"
              [(ngModel)]="row.value"
            />
            <span
              *ngIf="!isEditing || row.readOnly"
              class="onboarding-mini-table__value"
              [title]="row.value"
            >{{ row.value }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="onboarding-mini-table__table-scroll" *ngIf="hasTableRows">
      <app-dynamic-data-table
        *ngIf="activeTable?.dynamic; else legacyDataTable"
        [headers]="activeTable!.headers"
        [rows]="activeTable!.rows"
        [isDarkMode]="isDarkMode"
        [editable]="activeTable?.editable !== false"
        [isEditing]="isEditing"
      ></app-dynamic-data-table>
      <ng-template #legacyDataTable>
      <table class="module-data-table ch-api-data-table">
        <thead>
          <tr>
            <th *ngFor="let h of activeTable?.headers">{{ h }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="no-hover onboarding-detail-row" *ngFor="let r of activeTable?.rows; let ri = index">
            <td *ngFor="let cell of r; let ci = index">
              <input
                *ngIf="isEditing && activeTable?.editable !== false"
                class="form-control form-control-sm onboarding-mini-table__input"
                type="text"
                [(ngModel)]="activeTable!.rows[ri][ci]"
              />
              <span
                *ngIf="!isEditing || activeTable?.editable === false"
                class="onboarding-mini-table__value"
                [title]="cell"
              >{{ cell }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      </ng-template>
    </div>

    <ul class="ch-api-doc-list" *ngIf="uploadedFiles.length">
      <li class="ch-api-doc-list__item" *ngFor="let file of uploadedFiles; trackBy: trackFile">
        <div class="ch-api-doc-list__icon" aria-hidden="true">
          <mat-icon>{{ fileIcon(file) }}</mat-icon>
        </div>
        <div class="ch-api-doc-list__copy">
          <span class="ch-api-doc-list__name" [title]="file.fileName">{{ file.fileName }}</span>
          <span class="ch-api-doc-list__meta">{{ fileTypeLabel(file) }} · {{ formatFileSize(file.sizeBytes) }}</span>
        </div>
        <div class="ch-api-doc-list__actions">
          <button
            type="button"
            class="ch-api-file-btn"
            [disabled]="!canPreviewFile(file)"
            (click)="previewFile(file, $event)"
            matTooltip="Preview"
          >
            <mat-icon>visibility</mat-icon>
          </button>
          <button
            type="button"
            class="ch-api-file-btn"
            [disabled]="!canDownloadFile(file)"
            (click)="downloadFile(file, $event)"
            matTooltip="Download"
          >
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </li>
    </ul>
  </div>

  <div class="ch-api-empty-state" *ngIf="!hasKvRows && !hasTableRows && !uploadedFiles.length">
    <mat-icon class="ch-api-empty-state__icon">inbox</mat-icon>
    <p class="ch-api-empty-state__text">{{ emptyStateMessage }}</p>
  </div>
  </div>
</article>
